import { useMemo } from 'react';
import { DateRange } from '../types/dashboard.types';

export const useDateRangeSlider = (dateRange: DateRange | null, flightDates: string[] = []) => {
  const marks = useMemo(() => {
    if (!dateRange || flightDates.length === 0) return [];

    const totalDates = flightDates.length;

    if (totalDates <= 5) {
      return flightDates.map((_, index) => ({
        value: (index / (totalDates - 1)) * 100,
        label: ''
      }));
    }

    const markPositions = [0, 25, 50, 75, 100];
    return markPositions.map(pos => ({
      value: pos,
      label: ''
    }));
  }, [dateRange, flightDates]);

  const formatDateForSlider = (dateStr: string | undefined, includeTime: boolean = false): string => {
    if (!dateStr) return 'N/A';

    const parts = dateStr.match(/(\d{4})(\d{2})(\d{2})(?:_(\d{2})(\d{2})(\d{2}))?/);
    if (!parts) return dateStr;

    const [, year, month, day, hour, minute, second] = parts;
    const formattedDate = `${year}-${month}-${day}`;

    if (includeTime && hour && minute && second) {
      return `${formattedDate} ${hour}:${minute}:${second}`;
    }

    return formattedDate;
  };

  const formatDateShort = (dateStr: string): string => {
    if (dateStr.length === 8) {
      return `${dateStr.slice(0, 4)}-${dateStr.slice(4, 6)}-${dateStr.slice(6, 8)}`;
    }
    return dateStr;
  };

  const getSliderDateRange = (sliderValues: number[], flightDates: string[]): { start: string; end: string } => {
    if (flightDates.length === 0) {
      return { start: '', end: '' };
    }

    const startIndex = Math.floor((sliderValues[0] / 100) * (flightDates.length - 1));
    const endIndex = Math.round((sliderValues[1] / 100) * (flightDates.length - 1));

    return {
      start: flightDates[startIndex] || '',
      end: flightDates[endIndex] || ''
    };
  };

  return {
    marks,
    formatDateForSlider,
    formatDateShort,
    getSliderDateRange
  };
};
